export const SUPER_ADMIN = 'roles.super-admin'
export const ADMINISTRATOR = 'roles.administrator'
export const COMMUNITY_MANAGER = 'roles.community-manager'
export const MODERATOR = 'roles.moderator'
export const REGISTERED = 'roles.registered'
export const GUEST = 'roles.guest'

export type Role = 'roles.super-admin' | 'roles.administrator' | 'roles.community-manager' | 'roles.moderator' | 'roles.registered' | 'roles.guest'

export function canUserEditPost () {
  if (typeof window === 'undefined') {
    return false
  }
  return [ADMINISTRATOR, MODERATOR, SUPER_ADMIN].includes(window.inSidedData.user.mainRole)
}
